/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadge1 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.79 10.2v5.3h1.57V8.33h-1.11l-2.12 1.51v.92z" />
        <path d="M12.695 2.281a1 1 0 0 0-1.39 0L9.43 4.094l-2.58-.365a1 1 0 0 0-1.125.817l-.45 2.568-2.303 1.221a1 1 0 0 0-.43 1.323L3.687 12l-1.145 2.342a1 1 0 0 0 .43 1.323l2.303 1.221.45 2.568a1 1 0 0 0 1.125.817l2.581-.365 1.874 1.813a1 1 0 0 0 1.39 0l1.874-1.813 2.581.365a1 1 0 0 0 1.125-.817l.45-2.568 2.303-1.222a1 1 0 0 0 .43-1.322L20.313 12l1.145-2.342a1 1 0 0 0-.43-1.323l-2.303-1.221-.45-2.568a1 1 0 0 0-1.125-.817l-2.581.365zm-2.225 3.59L12 4.391l1.53 1.48a1 1 0 0 0 .835.272l2.107-.299.368 2.097a1 1 0 0 0 .516.71l1.88.998-.934 1.912a1 1 0 0 0 0 .878l.934 1.912-1.88.998a1 1 0 0 0-.516.71l-.368 2.096-2.107-.298a1 1 0 0 0-.835.272L12 19.609l-1.53-1.48a1 1 0 0 0-.835-.271l-2.107.298-.368-2.097a1 1 0 0 0-.516-.71l-1.88-.998.934-1.912a1 1 0 0 0 0-.878l-.934-1.912 1.88-.998a1 1 0 0 0 .516-.71l.368-2.097 2.107.299a1 1 0 0 0 .835-.272z" />
      </g>
    </g>
  </Icon>
);
export { SvgBadge1 as Badge1 };
